import React, { createRef, PureComponent } from 'react'
import data from '../../../data.json'
import { getPersistedResults, updatePersistedResults } from '../../helpers'
import getClassNameFactory from '@wel-ui/utility-class-names'
import ExistingUserStep from './ExistingUserStep'
import SFPoster from '../SFPoster'
import Step from './Step'
import SolutionBreadcrumb from '../SolutionBreadcrumb'
import './SolutionFinder.css'
import { connect } from 'react-redux'

import { PoseGroup } from 'react-pose'
import { CrossFade } from '../../animations'
import _ from 'lodash'

class SolutionFinder extends PureComponent {
  state = {
    chosenSteps: [],
    previouslyChosenSteps: [],
    ignorePreviouslyChosenSteps: false,
  }

  data = data

  displayName = 'SolutionFinder'

  constructor(...args) {
    super(...args)

    this.getClassName = getClassNameFactory(this.displayName)
    this.ref = createRef()
    this.isFinal = false
  }

  componentDidMount() {
    this.configureStateFromUrl()
    window.onpopstate = this.configureStateFromUrl

    this.configureStateForExistingUsers()
  }

  goBack = () => {
    const { chosenSteps } = this.state
    const updatedChosenSteps = [...chosenSteps.slice(0, chosenSteps.length - 1)]

    this.setState({
      chosenSteps: updatedChosenSteps,
    })

    window.history.back()
  }

  scrollToTop = () => {
    const element = this.ref.current
    const rect = element.getBoundingClientRect()

    // Only scroll if breadcrumb is off the page
    // NB Need to use top instead of y for IE support
    if (rect.top < 0) {
      window.scroll({ top: element.offsetTop, behavior: 'smooth' })
    }
  }

  chooseStep = (nextStep, nextStepKey) => {
    const chosenSteps = [...this.state.chosenSteps, nextStepKey]

    this.setState({
      nextStep,
    })

    this.setWindowUrl(nextStep)

    this.scrollToTop()
  }

  goToResultsPage = url => {
    window.location.href = url
  }

  chooseFinalStep = (e, nextStepKey, url) => {
    // need to wait for new props(containing their final answer) to flow in, which wont happen here,
    // so set a flag and take care of final step in another place
    this.isFinal = true
    this.url = url
  }

  startAgain = () => {
    this.setWindowUrl([])

    this.setState({
      ignorePreviouslyChosenSteps: true,
    })

    this.scrollToTop()
  }

  setWindowUrl = steps => {
    window.location.hash = steps.length ? `#${steps.join('+')}` : ''
  }

  checkStepsValid = stepKeys => {
    const dataStepKeys = Object.keys(this.data.steps)

    const validStepKeys = stepKeys.filter(
      value => dataStepKeys.indexOf(value) >= 0,
    )

    // True if all the keys are valid
    return validStepKeys.length === stepKeys.length
  }

  configureStateFromUrl = () => {
    const hash = window.location.hash
    const steps = hash.replace('#', '').split('+')

    if (steps.length > 0) {
      if (steps[0] === '') {
        this.setState({
          chosenSteps: [],
        })
      } else if (this.checkStepsValid(steps)) {
        this.setState({
          chosenSteps: steps,
        })
      }
    }
  }

  configureStateForExistingUsers = () => {
    const persistedResults = getPersistedResults() || []

    this.setState({
      previouslyChosenSteps: persistedResults,
    })

    if (persistedResults.length) {
      this.setWindowUrl([])
    }
  }

  doQuizLogic = (answers, tiebreakVal) => {
    const counted = _.countBy(answers, 'answerLetter')
    let max = 0
    let letter = 'tie'
    let tie = false
    for (const key in counted) {
      if (counted.hasOwnProperty(key)) {
        if (counted[key] === max) {
          tie = true
        }
        if (counted[key] > max) {
          max = counted[key]
          tie = false
          letter = key
        }
      }
    }
    if (tie) {
      const tiebreaker = answers.filter(a => a.question === tiebreakVal)
      return tiebreaker[0].answerLetter
    } else {
      return letter
    }
  }
  getStrength = answers => {
    const strengthAnswers = answers.filter(ans => {
      return (
        ans.question === 'q2' || ans.question === 'q5' || ans.question === 'q7'
      )
    })
    return this.doQuizLogic(strengthAnswers, 'q5')
  }
  getWeakness = answers => {
    const weaknessAnswers = answers.filter(ans => {
      return (
        ans.question === 'q1' ||
        ans.question === 'q3' ||
        ans.question === 'q4' ||
        ans.question === 'q6'
      )
    })
    return this.doQuizLogic(weaknessAnswers, 'q6')
  }
  doFinal = () => {
    const strength = this.getStrength(this.props.answers.answers)
    const weakness = this.getWeakness(this.props.answers.answers)

    // build urls here based on above
    const finalUrl = `${this.url[strength]}?strength=${strength}&weakness=${weakness}`
    this.goToResultsPage(encodeURI(finalUrl))
    return null
  }

  render() {
    const {
      chosenSteps,
      previouslyChosenSteps,
      ignorePreviouslyChosenSteps,
    } = this.state
    const { defaultStep, steps } = this.data
    const currentStep =
      chosenSteps.length === 0
        ? defaultStep
        : steps[chosenSteps[chosenSteps.length - 1]]
    const spacer =
      'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='

    const SFPosterOptions = {
      height: 'l',
      imageAnchor: currentStep.image ? currentStep.image.anchor : null,
      imageOverlay: 'scrimLeftLight',
      imageSrc: currentStep.image ? currentStep.image.src : spacer,
      imageSrcSet: currentStep.image ? currentStep.image.srcSet || '' : '',
    }
    // Returning user
    if (previouslyChosenSteps && !ignorePreviouslyChosenSteps) {
      const finalStepKey =
        previouslyChosenSteps[previouslyChosenSteps.length - 1]
      const finalStep = steps[finalStepKey]
      if (this.isFinal) {
        return <React.Fragment>{this.doFinal()}</React.Fragment>
      }
    }

      // New user, or returning user starting again
    return (
      <div className={this.getClassName()} ref={this.ref}>
        <div className={this.getClassName({ descendantName: 'breadcrumb' })}>
          <SolutionBreadcrumb
            chosenSteps={chosenSteps}
            onBackClicked={this.goBack}
          />
        </div>
        <SFPoster {...SFPosterOptions}>
          <div className={this.getClassName({ descendantName: 'content' })}>
            <Step
              step={currentStep}
              allSteps={steps}
              answers={currentStep.answers}
              onNextStepClick={this.chooseStep}
              onFinalStepClick={this.chooseFinalStep}
            />
          </div>
        </SFPoster>
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { answers } = state

  return { answers }
}
export default connect(
  mapStateToProps,
  null,
)(SolutionFinder)



// WEBPACK FOOTER //
// ./js/components/SolutionFinder/SolutionFinder.js